import OnboardingAppBar from "@features/auth/components/OnboardingAppBar";
import { handleNavigateBack } from "@helpers/common";
import { useDevice } from "@hooks/useDevice";
import { MaterialTopTabs } from "components/MaterialTopTabs";

export default function LegalLayout() {
	const { isMobile } = useDevice();
	return (
		<>
			<OnboardingAppBar
				onBackAction={() => handleNavigateBack("/")}
				showLogo={!isMobile}
				title="Read our rules & policies"
			/>
			<MaterialTopTabs />
		</>
	);
}
